import type { HelpCenterLogCorrelation } from '@zep-us/cs';
import { crmUserContext } from '@zep-us/cs/user-context';
import { createHelpCenterUserInfo } from '@zep-us/cs/user-info';

import {
  getApplicationSessionId,
  getBrowserSessionId,
  getDeviceId,
} from '@zep/session-id';
import type { User } from '@zep/types/auth';

export function toWebHelpCenterUserInfo(user: User | null | undefined) {
  return createHelpCenterUserInfo(user, user => ({
    id: user.hashId,
    email: user.snsId,
    name: user.name,
    context: {
      ...crmUserContext({ country_code: user.countryCode }),
      is_edu: user.isEdu,
      gm_level: user.gmLevel,
      sns_id: user.snsId,
    },
  }));
}

/** web 로거(shared/logger)와 같은 @zep/session-id getter 를 써야 ClickHouse 조회 값이 맞는다. */
export function getWebHelpCenterLogCorrelation(): HelpCenterLogCorrelation {
  return {
    deviceId: getDeviceId(),
    browserSessionId: getBrowserSessionId(),
    applicationSessionId: getApplicationSessionId(),
  };
}
